import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Colors } from "../../assets/Colors";
import { createSchema, Diagram, useSchema } from "beautiful-react-diagrams";
import "beautiful-react-diagrams/styles.css";
import {
  getCountStatusJobRequest,
  jobRequestTransaksiSelector,
} from "../hrd/transaksi/job-request/jobRequestTransaksiSlice";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../components/loading/Loading";
import { BiClipboard, BiPulse, BiBarChartAlt2, BiBuildingHouse } from "react-icons/bi";
import { FaShip } from "react-icons/fa";

// Menu halaman Operasional — tiap kartu dipasangkan ikon sesuai namanya.
// "Monitoring (Lama)" sengaja disembunyikan (2026-09-17): halaman
// penggantinya (Aktifitas / Job Request list) sudah menggantikan fungsinya.
const MENU_ICON = {
  JobRequest: BiClipboard,
  ShippingManifest: FaShip,
  Activity: BiPulse,
  Report: BiBarChartAlt2,
  Akomodasi: BiBuildingHouse,
};

const OperationalPage = ({}) => {
  const navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  const jobRequest = useSelector(jobRequestTransaksiSelector);
  const [firstLoading, setFirstLoading] = useState(false);
  let initialSchema = createSchema({
    nodes: [
      { id: "node-1", content: "Job Request", coordinates: [50, 50] },
      {
        id: "node-2",
        content: "Manifest (" + 0 + " Waiting)",
        coordinates: [250, 120],
      },
      {
        id: "node-3",
        content: "Permit (" + 0 + " Waiting)",
        coordinates: [400, 50],
      },
      {
        id: "node-4",
        content: "Activity (" + 0 + " Waiting)",
        coordinates: [550, 120],
      },
      {
        id: "node-5",
        content: "Approval Staff (" + 0 + " Waiting)",
        coordinates: [750, 50],
      },
      {
        id: "node-6",
        content: "Approval Client (" + 0 + " Waiting)",
        coordinates: [900, 120],
      },
    ],
    links: [
      { input: "node-1", output: "node-2", label: "", readonly: true },
      { input: "node-2", output: "node-3", label: "", readonly: true },
      { input: "node-3", output: "node-4", label: "", readonly: true },
      { input: "node-4", output: "node-5", label: "", readonly: true },
      { input: "node-5", output: "node-6", label: "", readonly: true },
    ],
  });

  useEffect(() => {
    dispatch(getCountStatusJobRequest());
  }, []);

  useEffect(() => {
    if (jobRequest.homeData && !firstLoading) {
      setFirstLoading(true);
    }
  });
  if (firstLoading) {
    initialSchema = createSchema({
      nodes: [
        { id: "node-1", content: "Job Request", coordinates: [50, 50] },
        {
          id: "node-2",
          content: "Manifest (" + jobRequest.homeData.Manifest + " Waiting)",
          coordinates: [250, 120],
        },
        {
          id: "node-3",
          content: "Permit (" + jobRequest.homeData.Permit + " Waiting)",
          coordinates: [400, 50],
        },
        {
          id: "node-4",
          content: "Activity (" + jobRequest.homeData.Activity + " Waiting)",
          coordinates: [750, 50],
        },
        {
          id: "node-5",
          content:
            "Approval Staff (" + jobRequest.homeData.Approval + " Waiting)",
          coordinates: [900, 120],
        },
        {
          id: "node-6",
          content:
            "Approval Client (" +
            jobRequest.homeData.ApprovalClient +
            " Waiting)",
          coordinates: [1100, 50],
        },
      ],
      links: [
        { input: "node-1", output: "node-2", label: "", readonly: true },
        { input: "node-2", output: "node-3", label: "", readonly: true },
        { input: "node-3", output: "node-4", label: "", readonly: true },
        { input: "node-4", output: "node-5", label: "", readonly: true },
        { input: "node-5", output: "node-6", label: "", readonly: true },
      ],
    });
  }

  const [schema, { onChange }] = useSchema(initialSchema);

  if (!firstLoading) {
    return <Loading />;
  } else {
    return (
      <div className="md:ml-64">
        <div className="w-full flex flex-col items-center mt-5">
          <div style={{ height: "15.5rem", width: "90%" }}>
            <Diagram schema={schema} onChange={onChange} />
          </div>

          <div className="w-full px-4 my-4 ">
            <div
              style={{ borderColor: Colors.primary }}
              className="flex flex-col border rounded"
            >
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 w-full px-2 py-2">
                {user.Otoritas.TOperationalMonitoring !== 0 && (
                  <MenuIconCard
                    Icon={MENU_ICON.JobRequest}
                    label="Job Request"
                    onClick={() => navigate("/operasional-job-request-list")}
                  />
                )}
                {/* Menu "Invoice" dipindah ke halaman Finance sebagai
                    "Invoice Quatation" (2026-08-03). Rutenya tetap
                    /invoice-list-v2, hanya titik masuknya yang berpindah.
                    "Monitoring (Lama)" (/operasional-job-request) disembunyikan
                    2026-09-17 — fungsinya sudah digantikan Job Request/Aktifitas. */}
                {user.Otoritas.TShippingManifest !== 0 && (
                  <MenuIconCard
                    Icon={MENU_ICON.ShippingManifest}
                    label="Verifikasi Shipping Manifest"
                    onClick={() => navigate("/operasional-shipping-manifest")}
                  />
                )}
                {user.Otoritas.TActivity !== 0 && (
                  <MenuIconCard
                    Icon={MENU_ICON.Activity}
                    label="Aktifitas"
                    onClick={() => navigate("/operasional-activity")}
                  />
                )}
                {user.Otoritas.TLJobRequest !== 0 && (
                  <MenuIconCard
                    Icon={MENU_ICON.Report}
                    label="Laporan Job Request"
                    onClick={() => navigate("/operasional-Summary")}
                  />
                )}
                {/* Akomodasi memakai otoritas yang sama dgn Job Request (TOperationalMonitoring):
                    denah room + penghuni (klien dari JR, karyawan/klien manual). */}
                {user.Otoritas.TOperationalMonitoring !== 0 && (
                  <MenuIconCard
                    Icon={MENU_ICON.Akomodasi}
                    label="Akomodasi"
                    onClick={() => navigate("/operasional-akomodasi")}
                  />
                )}
                {/* Mini-app terpisah (mobile-first/PWA) di /akomodasi/ — disajikan nginx sebagai
                    berkas statis, bukan rute React Router, jadi pakai navigasi penuh. */}
                {user.Otoritas.TOperationalMonitoring !== 0 && (
                  <MenuIconCard
                    Icon={MENU_ICON.Akomodasi}
                    label="Akomodasi (HP)"
                    onClick={() => window.location.assign("/akomodasi/")}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

// Kartu menu berbentuk ikon besar + label, dipakai untuk semua menu Operasional.
function MenuIconCard({ Icon, label, onClick }) {
  return (
    <div onClick={onClick} className="cursor-pointer">
      <div
        style={{ borderColor: Colors.primary }}
        className="flex flex-col items-center justify-center gap-2 border rounded-lg py-5 px-3 h-full text-center hover:shadow-md transition-shadow"
      >
        <Icon className="text-3xl" style={{ color: Colors.primary }} />
        <p className="text-sm font-medium text-gray-700">{label}</p>
      </div>
    </div>
  );
}

export default OperationalPage;
